import ApiService from "@/core/services/ApiService";

class personService {

    //obtener la lista de personas
    public static getData(params) {
        ApiService.setHeader()
        return ApiService.post('api/persons',params)
    }

    //obtener una persona 
    public static get(params) {
        ApiService.setHeader()
        return ApiService.get(`api/person/${params}`,'show')
    }

    //obtener la foto
    public static getPhoto(params) {
        ApiService.setHeader()
        return ApiService.post('api/photo',params)
    }

    public static update(id, data){
        ApiService.setHeader()
        return ApiService.put(`api/person/${id}/update`,data)
    }

    public static save(data:any){
        ApiService.setHeader()
        return ApiService.post(`api/person/save`,data)
    }

    //obtener el historial de participacion
    public static getHistorial(params){
        ApiService.setHeader()
        return ApiService.get(`api/person/${params}`,'history')
    }

    //obtener historial de sanciones
    public static getSanctions(params){
        ApiService.setHeader()
        return ApiService.get(`api/person/${params}`,'sanctions?field=idperson')
    }

    //Allergias
    public static deleteOptions(target: string, id:string,){
        ApiService.setHeader()
        return ApiService.delete(`api/${target}/${id}`, 'delete')
    }

    public static getOptions(params, slug){
        ApiService.setHeader()
        return ApiService.get(`api/person/${params}`, slug)
    }

    public static postOptions(slug: string, params: any){
        ApiService.setHeader()
        return ApiService.post(`api/person/${slug}`, params)
    }

}

export default personService;